/**
 * Shared list-export helpers for the Librarian section.
 * columns: [{ header: 'Name', key: 'name' }, ...]
 * rows: array of plain objects (row[key] is read directly, so format values beforehand)
 */
export const exportToCSV = (columns, rows, fileName) => {
  const header = columns.map((c) => `"${c.header}"`).join(',');

  const body = rows
    .map((row) =>
      columns
        .map((c) => `"${String(row[c.key] ?? '').replace(/"/g, '""')}"`)
        .join(',')
    )
    .join('\n');

  const csv = [header, body].join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.csv`;
  a.click();

  URL.revokeObjectURL(url);
};
